/* Lorens Cart Greeting Card - attribute-only behavior (free card, no product).
 * Pairs with snippets/lor-cart-gift-card.liquid. Loaded once from layout/theme.liquid.
 * Strategy: event delegation on document, idempotent, no double-binding.
 * States: offer (collapsed on mobile) / editing (textarea) / added (message shown).
 * The message is written to cart.attributes['הודעה לכרטיס'] via /cart/update.js,
 * then the drawer snippet is re-rendered from the server.
 */
(function () {
  if (window.__lorGiftCardBound) return;
  window.__lorGiftCardBound = true;

  var PROP = 'הודעה לכרטיס';
  var pendingEditMsg = null;

  function onCartPage() {
    try { return window.location && window.location.pathname.indexOf('/cart') === 0; } catch (e) { return false; }
  }

  function swapSnippet() {
    return fetch('/?sections=cart-drawer', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (sections) {
        if (!sections || !sections['cart-drawer']) return;
        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var fresh = doc.querySelector('[data-lor-gc]');
        document.querySelectorAll('[data-lor-gc]').forEach(function (live) {
          if (!fresh) { if (live.parentNode) live.parentNode.removeChild(live); }
          else { live.outerHTML = fresh.outerHTML; }
        });
      })
      .catch(function () {});
  }

  function refreshCart() {
    if (onCartPage()) { window.location.reload(); return; }
    swapSnippet();
  }

  function setOpen(root, open) {
    if (!root) return;
    var form = root.querySelector('[data-lor-gc-form]');
    var openBtn = root.querySelector('[data-lor-gc-open]');
    if (form) form.hidden = !open;
    if (openBtn) openBtn.hidden = open;
    root.classList.toggle('lor-gc--editing', !!open);
    if (open) root.classList.remove('lor-gc--collapsed');
    if (open && form) {
      var ta = form.querySelector('[data-lor-gc-textarea]');
      if (ta) { try { ta.focus({ preventScroll: true }); } catch (e) { ta.focus(); } }
      var saveBtn = form.querySelector('[data-lor-gc-save]');
      var target = saveBtn || form;
      if (target && target.scrollIntoView) {
        setTimeout(function () { target.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 60);
      }
    }
  }

  function updateAttribute(value) {
    var attrs = {};
    attrs[PROP] = value || '';
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) {
      if (!r.ok) throw new Error('update failed: ' + r.status);
      return r.json();
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    // header row: collapse / expand (mobile)
    var head = e.target.closest('[data-lor-gc-toggle]');
    if (head) {
      var boxT = head.closest('[data-lor-gc]');
      if (boxT && !boxT.classList.contains('lor-gc--editing')) boxT.classList.toggle('lor-gc--collapsed');
      return;
    }

    // open the form (offer -> editing)
    var openBtn = e.target.closest('[data-lor-gc-open]');
    if (openBtn) {
      e.preventDefault();
      var rootO = openBtn.closest('[data-lor-gc]');
      var taO = rootO && rootO.querySelector('[data-lor-gc-textarea]');
      if (taO && pendingEditMsg !== null) taO.value = pendingEditMsg;
      setOpen(rootO, true);
      return;
    }

    // edit an existing greeting: reopen the form prefilled
    var editBtn = e.target.closest('[data-lor-gc-edit]');
    if (editBtn) {
      e.preventDefault();
      var rootE = editBtn.closest('[data-lor-gc]');
      var taE = rootE && rootE.querySelector('[data-lor-gc-textarea]');
      if (taE) taE.value = editBtn.getAttribute('data-current-message') || '';
      setOpen(rootE, true);
      return;
    }

    // cancel: drop the draft, back to the previous state
    var cancelBtn = e.target.closest('[data-lor-gc-cancel]');
    if (cancelBtn) {
      e.preventDefault();
      var rootC = cancelBtn.closest('[data-lor-gc]');
      var taC = rootC && rootC.querySelector('[data-lor-gc-textarea]');
      if (taC) taC.value = '';
      pendingEditMsg = null;
      setOpen(rootC, false);
      return;
    }

    // save: write the attribute (empty text removes the greeting) and re-render
    var saveBtn = e.target.closest('[data-lor-gc-save]');
    if (saveBtn) {
      e.preventDefault();
      if (saveBtn.disabled) return;
      var root = saveBtn.closest('[data-lor-gc]');
      var ta = root && root.querySelector('[data-lor-gc-textarea]');
      var msg = ta ? (ta.value || '').trim() : '';
      var txt = saveBtn.querySelector('.lor-gc__btn-text');
      var origLabel = txt ? txt.textContent : '';
      saveBtn.disabled = true;
      if (txt) txt.textContent = 'שומר...';
      updateAttribute(msg)
        .then(function () { pendingEditMsg = null; refreshCart(); })
        .catch(function (err) {
          console.error('[lor-gc] save error', err);
          saveBtn.disabled = false;
          if (txt) txt.textContent = origLabel;
          alert('שגיאה בשמירת הברכה. נסי שוב.');
        });
      return;
    }
  });

  // keep the box in sync after native cart changes (quantity, remove, add)
  ['cart:refresh', 'cart:change', 'cart:updated'].forEach(function (evt) {
    document.addEventListener(evt, function () { swapSnippet(); });
  });
})();
